define('lq/webPushNotifications',[
    'underscore',
    'lq/main',
    'lq/dispatcher'
], function(_, main, dispatcher) {
    'use strict';

    var currentTokenKey = 'notifications.firebase_token';
    var currentRegistrationUserIdKey = 'notifications.user_id';

    var listeners = [];
    var notificationPermissionCallbacks = [];
    var receivedNotifications = [];

    var messaging;
    var swRegistration;
    var notificationsBroadcast;

    if (main.areWebNotificationsEnabled()) {
        var firebaseConfig = {
            apiKey: main.getFirebaseApiKey(),
            projectId: main.getFirebaseProjectId(),
            messagingSenderId: main.getFirebaseSenderId(),
            appId: main.getFirebaseAppId()
        };

        firebase.initializeApp(firebaseConfig);

        navigator.serviceWorker.getRegistration().then(function (registration) {
            swRegistration = registration;
            messaging = firebase.messaging();

            if (swRegistration && swRegistration.active) {
                swRegistration.active.postMessage({
                    type: 'FIREBASE_CONFIG',
                    config: firebaseConfig,
                    icon: main.getNotificationIcon(),
                    url: main.getNotificationsEntryPage()
                });
            }
        });
    }

    var callNotificationPermissionCallbacks = function (deviceId) {
        _.each(notificationPermissionCallbacks, function (callback) {
            callback(Notification.permission, deviceId)
        });
        notificationPermissionCallbacks = [];
    };

    var startReceiver = function (userId) {
        notificationsBroadcast = new BroadcastChannel('notifications');

        notificationsBroadcast.onmessage = function (e) {
            var message = e.data;

            receivedNotifications.push(message);

            _.each(listeners, function (listener) {
                listener(message);
            });
        }

        // Get registration token. Initially this makes a network call, once retrieved
        // subsequent calls to getToken will return from cache.
        messaging.getToken({
            serviceWorkerRegistration: swRegistration,
            vapidKey: main.getFirebaseWPCert()
        }).then(function (newToken) {
            var currentToken = localStorage.getItem(currentTokenKey);
            var registeredUserId = localStorage.getItem(currentRegistrationUserIdKey);

            if (currentToken !== newToken || registeredUserId !== userId) {
                dispatcher.dispatch('LicquidAction/RegisterMobileDevice',
                    {
                        deviceId: newToken,
                        messenger: "fcm",
                        platform: "web"
                    })
                    .done(function () {
                        localStorage.setItem(currentTokenKey, newToken)
                        localStorage.setItem(currentRegistrationUserIdKey, userId);

                        callNotificationPermissionCallbacks(newToken);
                    }, $.noop);
            } else {
                callNotificationPermissionCallbacks(newToken);
            }
        }).catch(function (err) {
            if (err.code === 'messaging/permission-blocked' && notificationPermissionCallbacks.length > 0)
                callNotificationPermissionCallbacks();
            else
                console.error(err);
        });

        // Handle incoming messages. Called when:
        // - a message is received while the app has focus
        // - the user clicks on an app notification created by a service worker
        //   `messaging.onBackgroundMessage` handler.
        messaging.onMessage(function (payload) {
            var message = payload.data;

            message.foreground = true;

            receivedNotifications.push(message);

            _.each(listeners, function (listener) {
                listener(message);
            });
        });
    };

    return {

        enableNotifications: function (userId, notificationPermissionCallback) {
            if (!messaging || !('Notification' in window)) return;
            notificationPermissionCallbacks.push(notificationPermissionCallback);
            startReceiver();
        },

        startReceivingNotifications: function (userId, notificationPermissionCallback) {
            if (!messaging || !('Notification' in window))
                return;

            notificationPermissionCallbacks.push(notificationPermissionCallback);

            if (Notification.permission !== "granted")
                return;

            startReceiver(userId);
        },

        hasReceivedNotifications: function () {
            return receivedNotifications.length > 0;
        },

        getAllReceivedNotifications: function () {
            return receivedNotifications;
        },

        addListener: function (callback) {
            listeners.push(callback);
        },

        removeListener: function (callback) {
            listeners = _.filter(listeners, function (otherCallback) {
                return otherCallback !== callback;
            });
        }

    };
});
